import { gql } from '@apollo/client'
import { IQueryBasicData, ID } from '../IQueryData'

export interface ICancelParkingPoolReservationDayVars {
  parkingSubscription: ID
  days: string[]
  comment?: string
}

export interface ICancelParkingPoolReservationDayData {
  cancelParkingPoolReservationDay: IQueryBasicData
}

export const CANCEL_PARKING_POOL_RESERVATION_DAY = gql`
  mutation cancelParkingPoolReservationDay(
    $parkingSubscription: ID!
    $days: [DateTime!]!
    $comment: String
  ) {
    cancelParkingPoolReservationDay(
      parking_subscription: $parkingSubscription
      days: $days
      comment: $comment
    ) {
      status
      message
      error
      code
    }
  }
`
